msgid ""
msgstr ""
"POT-Creation-Date: 2024-02-16 14:52+0100\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: nb_NO\n"
"Project-Id-Version: 69ffe877770b8fde5aa44a8b4a76deba\n"
"Report-Msgid-Bugs-To: \n"
"Last-Translator: \n"
"Language-Team: Norwegian Bokmal\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: 69ffe877770b8fde5aa44a8b4a76deba\n"
"X-Crowdin-Project-ID: 550\n"
"X-Crowdin-Language: nb\n"
"X-Crowdin-File-ID: 25212\n"

#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:32
#: src/components/Ad/lib/formatDistance.ts:49
msgid "distance.with-unit"
msgstr "{distance} km"

#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:13
msgid "distance.in-meters"
msgstr "{distance} meter"

#. Mobility unit, km for finn/dba, scandinavian mile for blocket
#. Mobility unit, km for finn/dba, scandinavian mile for blocket
#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:24
#: src/components/Ad/lib/formatDistance.ts:39
msgid "distance.mobility-unit"
msgstr "{distance} mil"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:61
msgid "explore.filter.range.label"
msgstr "Rekkevidde: {filterName}"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeForm.tsx:82
msgid "filters.range.maximum.label"
msgstr "{filterName}, maksimum"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeForm.tsx:68
msgid "filters.range.minimum.label"
msgstr "{filterName}, minimum"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:626
#: src/islands/search/SearchBar.tsx:622
msgid "explore.searchInput.filters.range.both"
msgstr "{min}–{max}"

#. js-lingui-explicit-id
#: src/components/Ad/lib/formatDistance.ts:7
msgid "distance.less-than-100m"
msgstr "100 meters eller mindre"

#. js-lingui-explicit-id
#: src/components/Ad/AdImageWrapper.tsx:22
msgid "search.ad.recommerce.image-alt"
msgstr "Annonsebilde"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/StandardFilter.tsx:120
msgid "explore.filters.all"
msgstr "Alle"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:134
#: src/islands/search/FiltersModal.tsx:141
msgid "explore.searchInput.filters.title"
msgstr "Alle filtre"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:853
msgid "explore.searchInput.filters.apply"
msgstr "Bruk"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:24
#: src/islands/header/Header.tsx:33
#: src/islands/search/StickySearchBar.tsx:76
#: src/islands/search/StickySearchBar.tsx:85
msgid "explore.back.button"
msgstr "Tilbake"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:127
msgid "explore.suggestions.title"
msgstr "Basert på søket"

#. js-lingui-explicit-id
#: src/islands/results/SearchResult.tsx:135
msgid "explore.results.title"
msgstr "Basert på søket"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:54
msgid "explore.header.badge"
msgstr "Beta"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:866
msgid "explore.searchInput.filters.clear.single"
msgstr "Nullstill"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:841
msgid "explore.searchInput.filters.clear"
msgstr "Nullstill alle"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:763
#: src/islands/search/SearchBar.tsx:778
msgid "explore.searchInput.clear"
msgstr "Slett tekst"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:176
#: src/islands/search/FiltersModal.tsx:181
msgid "explore.searchInput.filters.close"
msgstr "Lukk filtre"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:52
msgid "explore.results.errorstate.network.heading"
msgstr "Tilkoblingsfeil"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:74
msgid "explore.suggestions.title.discover.more"
msgstr "Oppdag mer"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:48
msgid "explore.header.title"
msgstr "Utforsk"

#. js-lingui-explicit-id
#: src/server/server.ts:170
msgid "page.title"
msgstr "Utforsk – gjør ditt neste FINN-kupp med AI"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:58
msgid "explore.sorting.info.body-try-it-two"
msgstr "Utforsk analyserer all informasjon i en annonse, inkludert bilder, når den leter etter resultatet. Det tradisjonelle søket på Torget søker bare gjennom annonseteksten."

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:55
msgid "explore.sorting.info.title-two"
msgstr "Utforsk analyserer tekst og bilder"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:26
msgid "explore.results.errorstate.server.message"
msgstr "Utforsk fungerer ikke akkurat nå, men vi er på saken. Prøv igjen senere!"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:36
msgid "explore.sorting.info.body-one"
msgstr "Utforsk bruker AI til å forstå hva du leter etter. Til forskjell fra det tradisjonelle søket på Torget, som bare viser resultater som inneholder det nøyaktige søkeordet, ser Utforsk forbi søkeord for å finne annonser som treffer intensjonen din."

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:57
#: src/islands/search/FiltersModal/filters/StandardFilter.tsx:60
#: src/islands/search/FiltersModal/filters/StandardFilter.tsx:86
msgid "explore.filter.fallback"
msgstr "Filtrer"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:137
msgid "explore.searchInput.filters.back"
msgstr "Filtrer"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:824
msgid "explore.searchInput.filters"
msgstr "Filtre"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:22
msgid "explore.sorting.info.trigger"
msgstr "Finn ut hvordan det fungerer"

#. js-lingui-explicit-id
#: src/islands/header/Header.tsx:61
msgid "explore.prompt.subtitle"
msgstr "Gjør ditt neste Torget-kupp med AI"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:638
#: src/islands/search/SearchBar.tsx:628
#: src/islands/search/SearchBar.tsx:687
msgid "explore.searchInput.filters.range.min"
msgstr "Fra {value}"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:70
msgid "explore.results.feedback.followup.button"
msgstr "Gi tilbakemelding"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:79
msgid "explore.results.errorstate.goback.label"
msgstr "Gå tilbake til søk på Torget"

#. js-lingui-explicit-id
#: src/islands/results/SearchResult.tsx:143
msgid "explore.results.count.hits"
msgstr "treff"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:29
msgid "explore.sorting.title"
msgstr "Hvordan fungerer Utforsk?"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:98
#: src/islands/suggestions/Suggestions.tsx:165
msgid "explore.suggestions.buttons.loading"
msgstr "Laster inn forslag"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:56
msgid "explore.suggestions.placeholder"
msgstr "Laster inn …"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:111
msgid "explore.searchInput.filters.range.max.label"
msgstr "Høyeste verdi"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:107
msgid "explore.searchInput.filters.range.min.label"
msgstr "Laveste verdi"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:102
msgid "explore.results.feedback.negative.label"
msgstr "Negativ tilbakemelding"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:707
msgid "explore.searchInput.filters.empty"
msgstr "Ingen filtre er tilgjengelige"

#. js-lingui-explicit-id
#: src/islands/results/ZeroResults.tsx:30
msgid "explore.results.zero-results.alt-text"
msgstr "Fant ingen resultater"

#. js-lingui-explicit-id
#: src/islands/results/ZeroResults.tsx:36
msgid "explore.results.zero-results.heading"
msgstr "Fant ingen resultater"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:37
msgid "explore.results.errorstate.client.heading"
msgstr "Å nei!"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:92
msgid "explore.results.feedback.positive.label"
msgstr "Positiv tilbakemelding"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeFilter.tsx:60
msgid "explore.filter.price.label"
msgstr "Prisintervall"

#. js-lingui-explicit-id
#: src/server/server.ts:171
msgid "page.description"
msgstr "Torget-side for å aktivere semantisk søk for utforskning"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:742
#: src/islands/search/SearchBar.tsx:791
msgid "explore.searchInput.ariaLabel"
msgstr "Søk"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:69
msgid "explore.sorting.info.body-try-it-two-rest"
msgstr "Søk på \"klær til sommerfest med kontoret\", så vil Utforsk foreslå klær som passer til anledningen."

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:33
msgid "explore.sorting.info.title-one"
msgstr "Søk med kontekst"

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:855
msgid "explore.searchInput.calloutText"
msgstr "Søk med en setning"

#. js-lingui-explicit-id
#: src/components/Ad/AdLocation.tsx:20
msgid "search.ad.bap.sold"
msgstr "Solgt"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:41
msgid "explore.results.errorstate.client.message"
msgstr "Noe gikk galt, og vi klarte ikke å laste inn noen elementer. Prøv igjen!"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:22
msgid "explore.results.errorstate.server.heading"
msgstr "Beklager!"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:26
msgid "explore.results.feedback.followup.negative"
msgstr "Takk! Vil du fortelle oss mer om hva du ikke likte?"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:21
msgid "explore.results.feedback.followup.positive"
msgstr "Takk! Vil du fortelle oss mer om hva du likte?"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal/filters/RangeForm.tsx:98
msgid "explore.filter.range.invalid"
msgstr "Maksimumsverdien kan ikke være mindre enn minimumsverdien."

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:795
msgid "explore.searchInput.helpText"
msgstr "Tips! Bruk beskrivende setninger"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:136
#: src/islands/results/ErrorState.tsx:142
msgid "explore.results.errorstate.retry.label"
msgstr "Prøv igjen"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:45
#: src/islands/results/SortingInfo.tsx:67
msgid "explore.sorting.info.try-it"
msgstr "Prøv det!"

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:131
msgid "explore.suggestions.title.discover"
msgstr "Prøv disse "

#. js-lingui-explicit-id
#: src/islands/results/ZeroResults.tsx:43
msgid "explore.results.zero-results.message"
msgstr "Prøv å omformulere søket eller justere filtrene for å finne det du leter etter."

#. js-lingui-explicit-id
#: src/components/Ad/AdImageOptions.tsx:15
msgid "search.ad.fallback-image-alt"
msgstr "To fjell og en sky"

#. js-lingui-explicit-id
#: src/islands/results/SortingInfo.tsx:47
msgid "explore.sorting.info.body-try-it-one-rest"
msgstr "Skriver du \"vintage kjøkkenutstyr\", vil Utforsk foreslå relevante annonser som eldre dekketøy, lamper og dekorasjon."

#. js-lingui-explicit-id
#: src/islands/suggestions/Suggestions.tsx:82
#: src/islands/suggestions/Suggestions.tsx:149
msgid "explore.suggestions.title.error"
msgstr "Kan ikke laste inn forslag – prøv igjen."

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:647
#: src/islands/search/SearchBar.tsx:634
#: src/islands/search/SearchBar.tsx:689
msgid "explore.searchInput.filters.range.max"
msgstr "Opptil {value}"

#. js-lingui-explicit-id
#: src/islands/search/FiltersModal.tsx:878
msgid "explore.searchInput.filters.use"
msgstr "Bruk"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:110
#: src/islands/results/ErrorState.tsx:116
msgid "explore.results.errorstate.help.center.label"
msgstr "Besøk hjelpesenteret"

#. js-lingui-explicit-id
#: src/islands/results/ErrorState.tsx:56
msgid "explore.results.errorstate.network.message"
msgstr "Klarer ikke å nå serverne. Sjekk internettilkoblingen og prøv igjen."

#. js-lingui-explicit-id
#: src/islands/search/SearchBar.tsx:787
msgid "explore.searchInput.placeholder"
msgstr "Hva leter du etter?"

#. js-lingui-explicit-id
#: src/islands/results/FeedbackPrompt.tsx:83
msgid "explore.results.feedback.prompt"
msgstr "Hva synes du om Utforsk?"

